import { keyBy } from 'lodash-es';
import { useCallback, useMemo } from 'react';

import { useLabelingBoxStore, usePcdRenderingStore } from '@/store';
import type { BoxWithIndex } from '@/type';
import { findOverlappingPairListRTree } from '@/util';

import { toGroupList } from '../util';

const useLabelingBoxOverlappingGroupList = () => {
  const pcdIndexBoxListMap = useLabelingBoxStore(
    state => state.pcdIndexBoxListMap,
  );
  const pcdIndex = usePcdRenderingStore(state => state.pcdIndex);
  const boxList = useMemo(
    () =>
      (pcdIndexBoxListMap[pcdIndex] ?? []).map((box, index) => ({
        ...box,
        index,
      })) as BoxWithIndex[],
    [pcdIndexBoxListMap, pcdIndex],
  );
  const getOverlappingGroupList = useCallback(() => {
    const boxMap = keyBy(boxList, box => box.id);
    const idPairList = findOverlappingPairListRTree({ boxList });

    return toGroupList(idPairList).map(idList => idList.map(id => boxMap[id]));
  }, [boxList]);

  return { getOverlappingGroupList };
};
export default useLabelingBoxOverlappingGroupList;
